import styled from 'styled-components';
export var LabelWrapper = styled.div.withConfig({
  displayName: "FilterSuggestionsstyles__LabelWrapper",
  componentId: "keen-query-creator__sc-1lny3b2-0"
})(["&&&{padding:14px 0 14px 14px;}"]);
export var LoaderWrapper = styled.div.withConfig({
  displayName: "FilterSuggestionsstyles__LoaderWrapper",
  componentId: "keen-query-creator__sc-1lny3b2-1"
})(["&&&{width:100%;display:flex;justify-content:center;padding-bottom:20px;box-sizing:border-box;}"]);
export var SuggestionsWrapper = styled.div.withConfig({
  displayName: "FilterSuggestionsstyles__SuggestionsWrapper",
  componentId: "keen-query-creator__sc-1lny3b2-2"
})(["&&&{box-sizing:border-box;}"]);